<template>
    <v-dialog v-model="show" max-width="900" persistent no-click-animation>
        <div class="QCBatchCreator">
            <div class="dialog-header">
                <div>{{ $f.tc('createQCBatch') }}</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <v-form
                v-model="formValid"
                ref="form"
                @submit="submit"
                style="max-height: 500px; overflow-y: auto; padding: 10px 12px"
                class="fci-scrollbar"
            >
                <div class="display-flex" style="gap: 6px;">
                    <div style="width: 50%;">
                        <div class="label mt-0">
                            {{ $f.tc('name') }}
                        </div>
                        <v-text-field
                            outlined
                            class="input-custom"
                            v-model="model.name"
                            :rules="formRules.required"
                        ></v-text-field>
                    </div>
                    <div style="width: 40%">
                        <div class="label mt-0">{{ $f.tc('time') }}</div>
                        <TimeRangePicker
                            ref="TimeRangePicker"
                            v-model="timeRange"
                            :button-class-name="'btn-primary'"
                            style="width: 352px"
                        ></TimeRangePicker>
                    </div>
                    <div style="width: 10%">
                        <div class="label mt-0">{{ $f.tc('amount') }}</div>
                        <v-text-field
                            type="number"
                            :min="0"
                            class="input-custom"
                            v-model="model.condition_config.amount"
                        ></v-text-field>
                    </div>
                </div>
                <div class="label">{{ $f.tc('assign') }}</div>
                <v-autocomplete
                    v-model="model.assign_to"
                    :items="assignList"
                    item-text="email"
                    item-value="email"
                    class="input-custom"
                    multiple
                ></v-autocomplete>
                <QCBatchConditionEditor
                    @updateItem="updateCondition"
                    ref="QCBatchConditionEditor"
                    :reset-condition-config="resetConditionConfig"
                    :conditions="copyCondition"
                ></QCBatchConditionEditor>
            </v-form>
            <div class="dialog-footer justify-space-between">
                <div v-if="isLoadingGetCallAvailable" class="btn-disable-2">
                    <img
                        class="mr-8"
                        src="/img/compare-grey-2.svg"
                        alt="icon-compare-2"
                    />
                    {{ $f.tc('callAvailable') }}:
                    <v-progress-circular
                        indeterminate
                        color="#727885"
                        class="ml-8"
                        style="height: 18px; width: 18px"
                    ></v-progress-circular>
                </div>
                <div v-else class="btn-secondary" @click="getCallAvailable">
                    <img
                        class="mr-8"
                        src="/img/compare-white.svg"
                        alt="icon-compare"
                    />
                    {{ $f.tc('callAvailable') }}:
                    <div class="ml-8">
                        {{ callQcAvailable }}
                    </div>
                </div>
                <div class="btn-primary" @click="submit">
                    {{ $f.tc('create') }}
                    <img class="ml-12" src="/img/save-member.svg" alt="icon-create"/>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import { mapState } from 'vuex'
import QcCampaignService from '@/services/qc.campaign.service'
import QCBatchConditionEditor from '@/views/QualityControl/Dialog/QCBatchConditionEditor'

const defaultModel = {
    name: '',
    assign_to: [],
    condition_config: {
        from_time: '',
        to_time: '',
        amount: '1',
        condition: []
    }
}

export default {
    name: 'QCBatchCreator',
    components: { TimeRangePicker, QCBatchConditionEditor },
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            timeRange: 'today',
            model: this.$utils.cloneObject(defaultModel),
            assignList: [],
            resetConditionConfig: false,
            callQcAvailable: 0,
            copyCondition: [],
            isLoadingGetCallAvailable: false,
            oldItem: {}
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign
        })
    },
    methods: {
        willOpen () {
            this.getAssignList()
        },
        open (item) {
            this.willOpen()
            this.$refs.form.resetValidation()
            this.resetModel()
            if (item) {
                if (item['id'] === this.oldItem['id']) {
                    item = this.oldItem
                } else {
                    this.oldItem = this.$utils.cloneObject(item)
                }
                
                this.model = {
                    name:
                        item.name +
                        ' clone - ' +
                        new Date().toLocaleDateString('en-US'),
                    condition_config: item.condition_config,
                    assign_to: item.assign_to
                }
                this.copyCondition = item.condition_config.condition
            }
            this.getCallAvailable()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        close () {
            this.show = false
            this.oldItem = {}
            this.resetConditionConfig = !this.resetConditionConfig
        },
        resetModel () {
            this.model = this.$utils.cloneObject(defaultModel)
            this.timeRange = 'today'
            this.copyCondition = []
        },
        getAssignList () {
            this.$appService.showLoading()
            let qcCampaignId = this.qcCampaign
                ? this.qcCampaign.id
                : this.$route.params.QCCampaignId
            QcCampaignService.UserPermissionService.search(qcCampaignId)
                .then(res => {
                    this.assignList = res.data
                })
                .finally(this.$appService.hideLoading)
        },
        submitValidForm () {
            let i18n = {
                action: this.$t('create'),
                item: this.$t('callList')
            }
            const { qcCampaignId, data } = this.convertDataRequest()
            QcCampaignService.CallListService.create(qcCampaignId, data)
                .then(() => {
                    this.$appService.handleRequestSuccess(
                        this.$f.tc('actionSuccessful', i18n)
                    )
                    this.$emit('reloadBatchList')
                })
                .finally(() => {
                    this.$refs.form.reset()
                    this.close()
                    this.$appService.hideLoading()
                })
        },
        updateCondition (list) {
            let condition = []
            list.forEach(item => {
                if (item.field === '' && item.value === '') return
                condition.push(item)
            })
            this.model.condition_config.condition = condition
        },
        convertDataRequest () {
            let qcCampaignId = this.qcCampaign
                ? this.qcCampaign.id
                : this.$route.params.QCCampaignId
            let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
            let data = this.$utils.cloneObject(this.model)
            data.condition_config.from_time = timeStamp.from
            data.condition_config.to_time = timeStamp.to
            data.condition_config.condition.forEach(item => {
                if (item.field === 'confidence' && item.source === 'nlp') {
                    item.from = item.from / 100
                    item.to = item.to / 100
                }
            })
            
            return { qcCampaignId, data }
        },
        getCallAvailable () {
            if (this.isLoadingGetCallAvailable === true) {
                this.$appService.toastInfo(this.$f.tc('loadingData'))
                return
            }
            this.isLoadingGetCallAvailable = true
            const { qcCampaignId, data } = this.convertDataRequest()
            QcCampaignService.getCallQcAvailable(qcCampaignId, data)
                .then(res => {
                    this.callQcAvailable = res.data.count
                })
                .finally(() => {
                    this.isLoadingGetCallAvailable = false
                })
        }
    }
}
</script>

<style scoped lang="scss">
.QCBatchCreator {
    background: #ffffff;
    position: relative;
    border-radius: 0 !important;
    overflow: hidden;
    
    .dialog-header {
        padding: 0 0 0 12px;
    }
    
    .label {
        margin-top: 12px;
        margin-bottom: 3px;
        font-family: "open sans semi", serif;
        font-size: 13px;
    }
    
    ::v-deep {
        .v-tabs__item--active {
            background: #25b570 !important;
        }
        
        .v-tabs__item {
            background: #e7edf5;
        }
        
        .v-tabs__bar {
            padding: 12px;
        }
        
        .v-tabs .v-tabs__bar .v-tabs__item {
            margin-right: 0 !important;
            border-radius: 0 !important;
        }
        
        .v-tabs__container {
            .v-tabs__div {
                margin-right: 10px;
                height: 70px;
                width: 254px !important;
                text-transform: none !important;
                font-weight: 400;
                
                &:last-child {
                    margin-right: 0 !important;
                }
            }
        }
        
        .v-tabs__item {
            align-items: flex-start;
            flex-direction: column;
        }
    }
}

.btn-custom {
    margin-left: 6px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #ffffff;
            border-radius: 0;
            border: 1px solid #dadfec;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;
            
            &:before,
            &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }
    
    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 11px;
    }
    
    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
    
    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0 !important;
    }
    
    .v-list__tile__action {
        min-width: 30px !important;
    }
}
</style>
